<template>
  <div class="row">
    <LoaderMaskComponent v-if="lyLoading" />
    <div v-else class="col_12">
      <div class="d_flex_btwn">
        <h1 class="common_title">
          <span v-if="$route.params.id">Edit Leave request</span>
          <span v-else>Create a New Leave request</span>
        </h1>
        <span>
          <router-link :to="{ name: 'leave-requests' }" class="btn btn_black"
            >Back to List</router-link
          >
        </span>
      </div>
      <div class="card border_none">
        <div class="card_body pl_0 pr_0">
          <div class="row">
            <div class="col_6 pr_20">
              <div class="row">
                <div class="col_6">
                  <div
                    :class="[
                      'form_row_inline',
                      { has_error: errorFor('start_date') },
                    ]"
                  >
                    <label class="required">Start date</label>
                    <div class="form_input">
                      <date-picker
                        v-model:input="user.start_date"
                      ></date-picker>
                      <v-errors :errors="errorFor('start_date')"></v-errors>
                    </div>
                  </div>
                </div>
                <div class="col_6">
                  <div
                    :class="[
                      'form_row_inline',
                      { has_error: errorFor('end_date') },
                    ]"
                  >
                    <label class="required">End date</label>
                    <div class="form_input">
                      <date-picker v-model:input="user.end_date"></date-picker>
                      <v-errors :errors="errorFor('end_date')"></v-errors>
                    </div>
                  </div>
                </div>
                <div class="col_12">
                  <div
                    :class="[
                      'form_row_inline',
                      { has_error: errorFor('leave_type') },
                    ]"
                  >
                    <label>Leave type</label>
                    <div class="form_input">
                      <select class="form_global" v-model="user.leave_type">
                        <option value="annual">Annual</option>
                        <option value="sick">Sick</option>
                        <option value="compensatory">Compensatory</option>
                      </select>
                      <v-errors :errors="errorFor('leave_type')"></v-errors>
                    </div>
                  </div>
                </div>
              </div>
              <div
                :class="[
                  'form_row_inline',
                  { has_error: errorFor('document') },
                ]"
              >
                <label> Document </label>
                <div class="form_input center_horizontally">
                  <input
                    ref="document"
                    type="file"
                    class="form_global"
                    accept="image/png, image/gif, image/jpeg"
                    @input="onFileChange($event)"
                  />
                </div>
                <div class="form_row_inline mt_10" v-if="tempFile">
                  <label></label>
                  <div class="inner_img p_relative display_inline">
                    <div class="cross_ic" @click.prevent="deleteFile">
                      <i class="fas fa-times"></i>
                    </div>
                    <img :src="tempFile" alt="" height="100" width="100" />
                  </div>
                </div>
                <div v-else class="form_row_inline mt_10">
                  <label></label>
                  <img
                    v-if="user.document"
                    :src="user.document"
                    alt=""
                    class=""
                    width="100"
                    height="100"
                  />
                </div>
              </div>
            </div>

            <div class="col_6 pl_20">
              <div
                :class="['form_row_inline', { has_error: errorFor('reason') }]"
              >
                <label class="">Reason</label>
                <div class="form_input">
                  <textarea
                    type="text"
                    class="form_global"
                    rows="5"
                    v-model="user.reason"
                  ></textarea>
                  <v-errors :errors="errorFor('reason')"></v-errors>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col_6">
              <div class="form_row_inline">
                <label></label>
                <div class="form_input">
                  <button
                    class="btn btn_primary"
                    :disabled="lyLoading"
                    @click.prevent="update"
                    v-if="$route.params.id"
                  >
                    Update
                  </button>
                  <button
                    class="btn btn_primary"
                    :disabled="lyLoading"
                    @click.prevent="submit"
                    v-else
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoaderMaskComponent from '@/components/LoaderMaskComponent.vue';
import DatePicker from '@/components/shared/DatePicker';
export default {
  name: 'user-form',
  components: { LoaderMaskComponent, DatePicker },
  data() {
    return {
      lyLoading: false,
      user: {
        start_date: '',
        end_date: '',
        reason: '',
        document: '',
        leave_type: 'annual',
      },
      tempFile: null,
    };
  },
  created() {
    if (this.$route.params.id) {
      this.loadData(this.$route.params.id);
    }
  },
  methods: {
    loadData(userId) {
      this.lyLoading = true;
      this.axios
        .get('/leave-requests/' + userId)
        .then((response) => {
          this.user = response.data.data;
        })
        .catch(() => {
          this.showFailMsg('No user exists!');
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },
    onFileChange(event) {
      let files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;

      let file = event.target.files[0];
      this.user.document = file;

      this.tempFile = URL.createObjectURL(file);
    },
    deleteFile() {
      this.tempFile = null;
      this.user.document = null;
      this.$refs.document.value = null;
    },
    submit() {
      this.allErrors = null;
      this.lyLoading = true;

      let formData = new FormData();

      Object.keys(this.user).forEach((key) => {
        formData.append(key, this.user[key] ? this.user[key] : '');
      });

      this.axios
        .post('/leave-requests', formData)
        .then(() => {
          this.resetForm();
          this.showSuccessMsg('Leave request Created Successfully!');
          this.$router.push({ name: 'leave-requests' });
        })
        .catch((err) => {
          this.allErrors = err.response.data.errors;
          this.showFailMsg(err.response.data.message);
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },

    update() {
      this.allErrors = null;
      this.lyLoading = true;

      let formData = new FormData();

      formData.append('_method', 'PATCH');

      Object.keys(this.user).forEach((key) => {
        formData.append(key, this.user[key] ? this.user[key] : '');
      });

      this.axios
        .post('/leave-requests/' + this.$route.params.id, formData)
        .then(() => {
          this.showSuccessMsg('Leave request Update Successfully!');
        })
        .catch((err) => {
          this.allErrors = err.response.data.errors;
          this.showFailMsg(err.response.data.message);
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },
    resetForm() {
      this.user = {
        start_date: '',
        end_date: '',
        reason: '',
        document: '',
        leave_type: 'annual',
      };
    },
  },
};
</script>
<style scoped>
.create_item_tab button {
  position: relative;
  float: right;
  right: 0;
  top: 0;
}
.btn_back {
  position: relative;
  float: right;
  right: 0;
  top: 0;
}
.font_italic {
  position: relative;
  display: block;
  left: 120px;
  padding-top: 5px;
}
</style>
